module.exports = __webpack_public_path__ + "img/linearAlgebra.6ffa1a8d.jpg";